import React, {
  forwardRef,
  useState,
} from "react";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { Accordion, AccordionDetails, AccordionSummary, Popover, Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { ReactComponent as InfoIcon } from "assets/img/svg/InfoGrayIcon.svg"
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import moment from "moment";
import { getStatusDetail, statusMapping, statusStyle } from "./constant";
// import { useGetCollectPaymentContext } from "../../context";
// import { validatePaymentMode } from "../components/constant";


const LogsDetailListing = forwardRef(
  (
    {
      loader,
      rowList = [],
      totalPaidAmount,
      setTotalAmount,
    },
    ref
  ) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [status, setStatus] = useState('')
    const [logData, setLogData] = useState({})
    const handleClick = (event, row) => {
      const { updatedBy, updatedOn, createdBy, createdOn, remark } = row
      setAnchorEl(event.currentTarget);
      setLogData({ updatedBy, updatedOn, createdBy, createdOn, remark })

    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "popover-dropdown" : undefined;


    const columns = [
      new AGridColDef("action", "Events", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip> : <div>-</div>
        )),
      new AGridColDef("value", "Value", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip> : <div>-</div>
        )),
      new AGridColDef("updatedOn", "Updated on", false)
        .setMinWidth(100)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={`${moment(params?.value).format('DD-MM-YYYY')} at ${moment(params?.value).format('HH:mm A')}`}>
            <div className={`ellipsis-text-container`}>{`${moment(params?.value).format('DD-MM-YYYY')} at ${moment(params?.value).format('hh:mm A')}`}</div>
          </Tooltip> : <div>-</div>
        )),
      new AGridColDef("status", "Status", false)
        .setMinWidth(60)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <div className="d-flex align-items-center justify-content-center" style={{ gap: '5px' }} ><InfoIcon onClick={(e) => { handleClick(e, params?.row); setStatus(params?.value) }} /><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`} style={statusStyle?.[statusMapping?.[(params?.value).toUpperCase()]]}>{statusMapping?.[(params?.value).toUpperCase()] ?? params?.value}</div>
          </Tooltip></div> : <div>-</div>
        )),
    ];
    const AccordionStyles = {
      boxShadow: "none",
      "&:before": { display: "none" },
      "&.Mui-expanded": { margin: "-15px 0" },
      ".MuiAccordionSummary-root:hover:not(.Mui-disabled)": { cursor: "auto" },
      ".MuiAccordionSummary-root": {
        color: "#FFFFFF",
        padding: "0 20px",
        // width:"98%",
        "&.Mui-expanded": { minHeight: 0 },
      },
      ".MuiCollapse-root": {
        backgroundColor: "#F5F2FD",
        color: "#0F0F0F",
        borderRadius: "0 0 12px 12px",
      },
      ".MuiAccordionDetails-root": { padding: "0px" },
    };

    return (<>

      <Accordion className="mb-4">
        <AccordionSummary
          expandIcon={<DownArrow />}
          aria-controls="panel-content"
          id="panel-header"
          sx={AccordionStyles}
        >
          <div className="large-text">Logs</div>
        </AccordionSummary>
        <AccordionDetails>
          <ADataGrid
            removeWrapperContainer
            rowModesModel
            rows={rowList || []}
            columns={columns}
            rowId={(row) => row?.id}
            rowHeight={50}
            rowCount={rowList.length}
            loading={false}
            components={{
              ...gridComponents,
              NoRowsOverlay: () => (
                <NoRowOverlay message={loader ? "Loading..." : null} />
              ),
            }}
            sx={{
              ...gridStyles,
            }}
            autoHeight
            hidePagination={true}
          />
        </AccordionDetails>
      </Accordion>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}

      >
        <div style={{ padding: '16px', gap: '12px' }}>
          <div className="label-color regular-bolder">{getStatusDetail(status, 'heading', logData?.updatedBy)}</div>
          <div className="regular-small" style={{ color: '#000000' }}>{status != 'Approved'? (status == 'Pending' ? `Request is submitted by ${logData?.createdBy}` : logData?.remark):''}</div>
          <div style={{ fontSize: '8px', fontWeight: '400px', lineHeight: '10px', color: '#000000' }}>
            {status == 'Pending' ?
              moment(logData?.createdOn).format('DD-MM-YYYY hh:mm A')
              : moment(logData?.updatedOn).format('DD-MM-YYYY hh:mm A')}</div>
        </div>
      </Popover>


      {/* <div className="" style={{border:'1px solid #EEE', borderRadius:'8px'}}>
          
        </div>
        <div className="d-flex justify-content-between align-items-center mt-24 large-text">
            <span className="label-color">
                Total Amount Paid
            </span>
            <span style={{color:'#07794C'}}>
                {`₹ ${totalPaidAmount}`}
            </span>
        </div> */}
    </>
    );
  }
);
export default LogsDetailListing;
